import React, { useState, useContext, useEffect, useRef } from 'react'
import ReactDOMServer from 'react-dom/server'
import ContentCTA from '@3mcom/mds-library/dist/node/ContentCTA'
import { StateContext } from '../services/StateService'
import { Translations } from '../services/TranslationService'
import { SF_CONFIG, SF_CONFIG_HC } from '../constants/PDPConstants'
import ContactUsForm from './ContactUsForm'
import { getSalesforceConfig } from '../services/PDPService'

const ContactUs = () => {
    const { richContent, contactUs, productDetails } = useContext(StateContext)
    const {
        chatPortalId,
        chatQuestionaireId,
        messageMailBinId,
        productSupportNumber,
        productSalesSupportNumber
    } = contactUs || {}
    const { supportForm } = richContent || {}
    const translations = useContext(Translations)
    const { messageUsHeader, supportTitle, supportDescription } = translations
    const sfConfig = getSalesforceConfig(
        productDetails?.divisionCode,
        SF_CONFIG,
        SF_CONFIG_HC
    )

    // needs to be change to TMT Keys
    const formContainerRef = useRef(null)
    const [showForm, setShowForm] = useState(false)

    useEffect(() => {
        if (showForm) {
            formContainerRef?.current?.scrollIntoView()
        }
    }, [showForm])

    const phoneLink = (phone) => {
        return ReactDOMServer.renderToStaticMarkup(<a href={`tel:${phone}`}>{phone}</a>)
    }

    const phoneNumbers = `${
        productSupportNumber ? phoneLink(productSupportNumber) : ''
    } ${productSalesSupportNumber ? phoneLink(productSalesSupportNumber) : ''}`
    const hasMessageCta = !!(messageMailBinId || supportForm)

    const supportDescriptionContent = supportDescription?.replace('{#}', phoneNumbers)

    if (
        !productSupportNumber &&
        !productSalesSupportNumber &&
        !messageMailBinId &&
        !supportForm
    ) {
        return null
    }
    return (
        <div className="mds-margin_xLarge--bottom">
            <ContentCTA
                grayBack={true}
                title={supportTitle}
                content={supportDescriptionContent}
                cta1_text={hasMessageCta ? messageUsHeader : undefined}
                cta1_ariaLabel={hasMessageCta ? messageUsHeader : undefined}
                cta1_buttonType="secondary"
                cta1_icon="icon_envelope_email_1"
                cta1_func={
                    hasMessageCta
                        ? () => setShowForm((prevState) => !prevState)
                        : undefined
                }
                contentAlignment="center"
            />
            {chatPortalId && chatQuestionaireId && (
                <script
                    type="text/javascript"
                    data-testid="mmmChatButtonSettings"
                    dangerouslySetInnerHTML={{
                        __html: `
                                    var mmmChatButtonSettings = {};//should be defined in mmmSettings.js as placeholder variable

                                    mmmChatButtonSettings.snaps = {
                                        orgID: '${sfConfig.ORG_ID}',
                                        chatButtonID: '${chatPortalId}',
                                        deploymentID: '${chatQuestionaireId}',
                                        liveAgentJS: '${sfConfig.LIVE_AGENT_JS}',
                                        onlineSelector: '.sps2-pdp_support--chat_button--online',
                                        offlineSelector: '.sps2-pdp_support--chat_button--offline',
                                        linkSelector: '[href=###ChatButtonSnaps###]'
                                    }
                                    ${sfConfig.DEPLOYMENT_JS_URL ? `mmmChatButtonSettings.snaps.deploymentJSURL = '${sfConfig.DEPLOYMENT_JS_URL}'` : ''}
                                    loadPageModule('kungfu/chatButtons/initChat');
                                `
                    }}
                ></script>
            )}
            {hasMessageCta && (
                <ContactUsForm
                    formContainerRef={formContainerRef}
                    setShowForm={setShowForm}
                    showForm={showForm}
                />
            )}
        </div>
    )
}

export default ContactUs
